import PlanetSub from './sub-task/planet-sub'

export default [
  // orderAbout
  {
    path: '/planet',
    name: 'planet',
    component: () =>
    import(/* webpackChunkName: "planet" */ '@/components/planet'),
    children: [
      ...PlanetSub
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/planet.js